import { render, staticRenderFns } from "./AssignedDriver.vue?vue&type=template&id=afd587d2"
import script from "./AssignedDriver.vue?vue&type=script&lang=js"
export * from "./AssignedDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports